import log from '@/services/logger/log';

let installPrompt = undefined;

export const initInstallPrompt = (prompt) => {
    prompt.preventDefault();

    log.info('Install PWA prompt inited');

    setInstallPrompt(prompt);
};

const setInstallPrompt = (prompt) => {
    installPrompt = prompt;
};

export const getInstallPrompt = () => {
    return installPrompt;
};
